/**
 * Toast 提示 composable
 * 提供统一的提示消息功能，替代系统 alert
 */
export function useToast() {
  const showToast = (message, type = 'info', duration = 3000) => {
    // 如果 Toast 组件已挂载，使用全局实例
    if (window.__toast) {
      return window.__toast.showToast(message, type, duration)
    }
    
    // 如果还未挂载，延迟执行
    setTimeout(() => {
      if (window.__toast) {
        window.__toast.showToast(message, type, duration)
      } else {
        // 降级到 console（开发环境）
        console[type === 'error' ? 'error' : 'log'](message)
      }
    }, 100)
  }

  const success = (message, duration = 3000) => {
    return showToast(message, 'success', duration)
  }

  const error = (message, duration = 3000) => {
    return showToast(message, 'error', duration)
  }

  const warning = (message, duration = 3000) => {
    return showToast(message, 'warning', duration)
  }

  const info = (message, duration = 3000) => {
    return showToast(message, 'info', duration)
  }

  return {
    showToast,
    success,
    error,
    warning,
    info
  }
}

